"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/HMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_101)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_101`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.27723 14.9193L8.04916 16.5263L9.78249 16.1263L9.00354 17.7263L10.4 18.8351L8.6667 19.228V21.0105L7.27723 19.8947L5.88775 21.0105L5.89477 19.228L4.15442 18.8351L5.55091 17.7263L4.77196 16.1263L6.51231 16.5263L7.27723 14.9193ZM21.1649 16.9193L21.5299 17.6842L22.3579 17.4947L21.986 18.2596L22.6527 18.7859L21.8246 18.9684V19.8245L21.1649 19.2912L20.4983 19.8245L20.5053 18.9684L19.6702 18.7859L20.3369 18.2596L19.9649 17.4947L20.8 17.6842L21.1649 16.9193ZM17.7544 8.77891L18.1193 9.54383L18.9474 9.35435L18.5755 10.1193L19.2421 10.6456L18.4141 10.8351V11.6842L17.7544 11.1508L17.0878 11.6842V10.8351L16.2597 10.6456L16.9263 10.1193L16.5544 9.35435L17.3825 9.54383L17.7544 8.77891ZM21.1649 4.1333L21.5299 4.89821L22.3579 4.70874L21.986 5.47365L22.6527 5.99997L21.8246 6.18944V7.03856L21.1649 6.50523L20.4983 7.03856L20.5053 6.18944L19.6702 5.99997L20.3369 5.47365L19.9649 4.70874L20.8 4.89821L21.1649 4.1333ZM24.1404 7.62102L24.5123 8.38593L25.3404 8.19646L24.9685 8.96137L25.6351 9.48769L24.8071 9.67014V10.5263L24.1404 9.99295L23.4807 10.5263V9.67014L22.6527 9.48769L23.3193 8.96137L22.9474 8.19646L23.7755 8.38593L24.1404 7.62102ZM22.0141 11.6842L22.3018 12.5754H23.2351L22.4772 13.1228L22.7649 14.007L22.0141 13.4596L21.2562 14.007L21.5439 13.1228L20.793 12.5754H21.7263L22.0141 11.6842Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 0V2.14737L8.79298 3.90877H11.9649V8.07018H7.81754L11.9649 10.3719V11.9789H10.0912L4.93333 9.10877V11.9789H1.03158V8.56842L-5.10877 11.9789H-6V9.83158L-2.82807 8.07018H-6V3.90877H-1.85263L-6 1.6V0H-4.12632L1.03158 2.86316V0H4.93333V3.41053L11.0737 0H11.9649Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.10526 0H1.85965V4.86316H-6V7.10877H1.85965V11.9789H4.10526V7.10877H11.9649V4.86316H4.10526V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.93335 8.07007L11.9649 11.9788V10.8701L6.92633 8.07007H4.93335Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.93335 8.07007L11.9649 11.9788V10.8701L6.92633 8.07007H4.93335Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.93333 8.07007L11.9649 11.9788V10.8701L6.92632 8.07007H4.93333ZM-0.961403 8.07007L-6 10.8701V11.9788L1.03158 8.07007H-0.961403Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.03158 3.90175L-6 0V1.10175L-0.961403 3.90175H1.03158Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.03158 3.90175L-6 0V1.10175L-0.961403 3.90175H1.03158Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.03158 3.90175L-6 0V1.10175L-0.961403 3.90175H1.03158ZM6.92632 3.90175L11.9649 1.10175V0L4.93333 3.90175H6.92632Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_101`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as HMFlag };
